import { functions } from 'firebase/app'

import * as transactionService from '../services/transactions'

import { LIST_TYPE } from '../constant'


export const getTransactions = options => async (dispatch) => {
  dispatch({ type: 'GET_LIST' })

  try {
    const items = await transactionService.getTransactions(options)
    console.log("--- items", items)

    return dispatch({
      items,
      type: 'GET_LIST_SUCCESS',
      listType: LIST_TYPE.TRANSACTIONS,
    })
  } catch (err) {
    return dispatch({
      message: err.message,
      type: 'GET_LIST_ERROR',
    })
  }
}


export const getPendingRefundTransactions = options => async (dispatch) => {
  dispatch({ type: 'GET_LIST' })

  try {
    const items = await transactionService.getPendingRefundTransactions(options)

    return dispatch({
      items,
      type: 'GET_LIST_SUCCESS',
      listType: LIST_TYPE.REFUNDS,
    })
  } catch (err) {
    console.error(err)
    return dispatch({
      message: err.message,
      type: 'GET_LIST_ERROR',
    })
  }
}


export const getSuccessfulRefundTransactions = options => async (dispatch) => {
  dispatch({ type: 'GET_LIST' })

  try {
    const items = await transactionService.getRefundTransactions({
      ...options,
      direction: 'desc',
      orderBy: 'refund_date',
    })

    return dispatch({
      items,
      type: 'GET_LIST_SUCCESS',
      listType: LIST_TYPE.REFUNDS,
    })
  } catch (err) {
    console.error(err)
    return dispatch({
      message: err.message,
      type: 'GET_LIST_ERROR',
    })
  }
}


export const triggerRefundTransactions = transactionIds => async (dispatch) => {
  dispatch({ type: 'LOADING' })

  try {
    await functions().httpsCallable('triggerTransactionsRefund')({ transactionIds })
  } catch (err) {
    console.error(err)

    dispatch({
      type: 'SNACK_ERROR',
      message: 'Impossible de mettre à jour les transactions',
    })
  }

  return dispatch({ type: 'UNLOAD' })
}
